import { FilterPreset } from '@/types/filter-presets';
import { apiBaseUrl } from '@/utils/constants';

import { ENTITIES } from './api.constant';

const fields$base = (['display', 'country', 'company'] satisfies Array<keyof FilterPreset>).join(',');
export async function filterPresets$get$base(id: string): Promise<FilterPreset | null> {
    const url = `${apiBaseUrl}${ENTITIES.filterPresets}/${id}?fields=${fields$base}`;
    const response = await fetch(url, { next: { revalidate: 7200 } }).then((res) => res.json());
    return response?.data || null;
}
